import { render, staticRenderFns } from "./RfDataInfoPop.vue?vue&type=template&id=01efc767&scoped=true"
import script from "./RfDataInfoPop.vue?vue&type=script&lang=js"
export * from "./RfDataInfoPop.vue?vue&type=script&lang=js"
import style0 from "./RfDataInfoPop.vue?vue&type=style&index=0&id=01efc767&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01efc767",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01efc767')) {
      api.createRecord('01efc767', component.options)
    } else {
      api.reload('01efc767', component.options)
    }
    module.hot.accept("./RfDataInfoPop.vue?vue&type=template&id=01efc767&scoped=true", function () {
      api.rerender('01efc767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/RfDataInfoPop.vue"
export default component.exports